import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

// @ts-ignore
const firebaseConfig = require('./firebase-config.js').firebaseConfig;
firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
firestore.settings({});

const auth = firebase.auth();

const listsCollection = firestore.collection('lists');
const itemsCollection = firestore.collection('items');
const usersCollection = firestore.collection('users');
const userListSlugCollection = firestore.collection('userListSlug');
const inviteCodesCollection = firestore.collection('inviteCodes');
const emailsCollection = firestore.collection('emails');

export {
  firestore,
  auth,
  listsCollection,
  itemsCollection,
  usersCollection,
  userListSlugCollection,
  inviteCodesCollection,
  emailsCollection,
  firebaseConfig
};
